import { posToDOMRect } from '@tiptap/core';
import { ReelsSmall } from '@wix/wix-ui-icons-common';

import { TIPTAP_GIF_TYPE } from './../ricos-content';
import type { EditorPluginCreator } from './../ricos-types';
import { quickActionsModalSections, RicosPluginToolbarNames } from './../ricos-types';
import { changeSelectionToEndOfTextBlock } from './../wix-rich-content-common';

import { pluginFigure } from '../plugin-figure/editor';
import { DEFAULT_CONFIGS, gifModals } from './constants';
import { gifConverter } from './converter/gif-converter';
import { getAddButtons } from './getAddButtons';
import { getToolbarButtons } from './getToolbarButtons';
import { GiphyInsertModal } from './modals/InsertModal';
import { tiptapExtensions } from './tiptap/tiptap';
import type { GiphyPluginEditorConfig } from './types';
import { GIPHY_TYPE } from './types';

export const pluginGiphy: EditorPluginCreator<
  GiphyPluginEditorConfig,
  { InsertModal: typeof GiphyInsertModal }
> = config => {
  const pluginConfig = { ...DEFAULT_CONFIGS.editor, ...config };
  return {
    config: pluginConfig,
    pmMarkConverters: [],
    pmNodeConverters: [gifConverter],
    type: GIPHY_TYPE,
    tiptapExtensions,
    getAddButtons: (config, services) => getAddButtons(config, services),
    toolbar: {
      names: [RicosPluginToolbarNames.GIF],
      getButtons: (config, services) => getToolbarButtons(config, services),
      resolveReferenceElement: tiptapEditor => {
        const startNodePos = tiptapEditor.state.selection.$from;
        if (startNodePos.nodeAfter?.type.name !== TIPTAP_GIF_TYPE) {
          return null;
        }
        return tiptapEditor.view.nodeDOM(startNodePos.pos - 1) as HTMLElement | null;
      },
    },
    getQuickActions: ({ config, pluginServices }) => [
      {
        id: 'giphy',
        title: 'GIF',
        icon: ReelsSmall,
        section: quickActionsModalSections.Media,
        tags: ['animation', 'motion', 'clip', 'short', 'funny', 'meme', 'loop'],
        command: ({ modalService, editor }) => {
          changeSelectionToEndOfTextBlock(editor);

          modalService.togglePluginPanel({
            id: gifModals.insert,
            Component: GiphyInsertModal,
            componentProps: {
              modalId: gifModals.insert,
              getGiphyUrl: config?.getGiphyUrl,
            },
            isMobile: pluginServices?.context.isMobile,
            positioning: {
              referenceElement: {
                getBoundingClientRect: () =>
                  posToDOMRect(
                    editor.view,
                    editor.view.state.selection.from,
                    editor.view.state.selection.to
                  ),
              },
              placement: 'bottom-end',
            },
          });
        },
      },
    ],
    dependencies: [pluginFigure],
    __exports: {
      InsertModal: GiphyInsertModal,
    },
  };
};
